import type { FrequentCustomerCard } from '@washday/utilities';
import { CUSTOMER_BULK, GET_SET_CUSTOMERS } from '../utils/api';
import { getData, postData } from '../utils/api-service';
import WashdayClientSingleton from './WashdayClientSingleton';

export const getCustomerOrdersById = async (customerID, pageNum = 0, limit = 0, t = () => { }) => {
  try {
    const res = await getData(
      `${GET_SET_CUSTOMERS}/${customerID}/orders?pageNum=${pageNum}&limit=${limit}`,
      null,
      t
    );
    const data = {
      orders: res.data?.data?.orders || [],
      totalRowsCount: res.data?.data?.totalRowsCount || 0
    };
    return data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const getCustomersOrdersByName = async (customerName, t = () => { }) => {
  try {
    const res = await getData(`${GET_SET_CUSTOMERS}?name=${customerName}`, null, t);
    return res?.data?.data?.customers || [];
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const customerBulkByStore = async (storeID, putObj, t = () => { }) => {
  try {
    const res = await postData(`${CUSTOMER_BULK}`, putObj, null, t('alerts.success'), t);
    return res;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    return e;
  }
};

export const customerHighlightsById = async (customerId) => {
  try {
    const res = await WashdayClientSingleton.getInstance().customers.getCustomerHighlightsById(customerId);
    return { ...res.data };
  } catch (e) {
    console.log('ERROR CUSTOMER HIGHLIGHT', e);
    throw e;
  }
};

// WASHDAY SDK ENDPOINTS
export const getCustomersV2 = async (params: {
  searchTerm?: string
  name?: string
  phone?: string
  email?: string
  fromDate?: string
  toDate?: string
  limit: number
  pageNum: number,
  includeOrderMetrics?: string
  signal?: AbortSignal
}) => {
  return WashdayClientSingleton.getInstance().customers.getCustomers(params, { signal: params.signal });
};

export const getCustomerByIdV2 = async (id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().customers.getCustomerById(id);
  } catch (e) {
    console.log('ERROR getCustomerByIdV2', e);
    throw e;
  }
};

export const getCustomerHighlightsByIdV2 = async (id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().customers.getCustomerHighlightsById(id);
  } catch (e) {
    console.log('ERROR getCustomerHighlightsByIdV2', e);
    throw e;
  }
};

export const getCustomerOrdersV2 = async (id: string, params: {
  limit: number
  pageNum: number
}) => {
  try {
    return await WashdayClientSingleton.getInstance().customers.getCustomerOrders(id, params);
  } catch (e) {
    console.log('ERROR getCustomerOrdersV2', e);
    throw e;
  }
};

export const createCustomerV2 = async (data: {
  name: string;
  frequentCustomerCard?: FrequentCustomerCard | null;
  lastName?: string;
  phone?: string;
  email?: string;
  address?: IAddress;
  notes?: string;
  privateNotes?: string;
  discount: number;
  credit: number;
  rfc?: string;
  invoiceInfo?: {
    legal_name?: string;
    tax_system?: string;
    zipCode?: string;
    applyIsrRetention?: boolean;
  };
  isActive: boolean;
}) => {
  try {
    return await WashdayClientSingleton.getInstance().customers.create(data);
  } catch (e) {
    console.log('ERROR createCustomerV2', e);
    throw e;
  }
};

export const updateCustomerByIdV2 = async (id: string, data: {
  name?: string;
  frequentCustomerCard?: FrequentCustomerCard | null;
  phone?: string;
  email?: string;
  address?: string;
  notes?: string;
  privateNotes?: string;
  discount?: number;
  credit?: number;
  rfc?: string;
  invoiceInfo?: {
    legal_name?: string;
    tax_system?: string;
    zipCode?: string;
    applyIsrRetention?: boolean;
  };
  isActive?: boolean;
}) => {
  try {
    return await WashdayClientSingleton.getInstance().customers.updateById(id, data);
  } catch (e) {
    console.log('ERROR updateCustomerByIdV2', e);
    throw e;
  }
};

export const deleteCustomerByIdV2 = async (id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().customers.deleteById(id);
  } catch (e) {
    console.log('ERROR deletCustomerByIdV2', e);
    throw e;
  }
};

export const exportCustomerListV2 = async (params: {
  searchTerm?: string
  name?: string
  phone?: string
  email?: string
  fromDate?: string
  toDate?: string,
  createdIn?: string
}) => {
  try {
    return await WashdayClientSingleton.getInstance().csv.exportCustomersList(params);
  } catch (e) {
    console.log('ERROR exportCustomerList', e);
    throw e;
  }
};


export const customersBulkCreate = async (storeID: string, data: FormData) => {
  try {
    const res = await WashdayClientSingleton.getInstance().customers.bulkCreate(storeID, data);
    return { ...res.data };
  } catch (e) {
    console.log('ERROR productBulkByStoreV2', e);
    throw e;
  }
};

export const getCustomerLoyaltyHistory = async (id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().customers.getCustomerLoyaltyHistory(id);
  } catch (e) {
    console.log('ERROR getCustomerLoyaltyHistory', e);
    throw e;
  }
};
